import Vue from 'vue'

import App from './App.vue'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './assets/styles/vuetify-override.css'
import './assets/styles/vuetify-fixes.css'
import { getApiConfig } from './config/api'
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/fr'
import numeral from 'numeral'

import VueFriendlyIframe from 'vue-friendly-iframe';
import FlashMessage from '@smartweb/vue-flash-message'


Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuetify)
Vue.use(VueSession)
Vue.use(VueAxios, axios)
Vue.use(moment)
Vue.use(numeral)

// Mois/jours en français partout (moment est en anglais par défaut).
moment.locale('fr')
Vue.use(VueFriendlyIframe);
Vue.use(FlashMessage)


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatNumber', function(value) {
  if (value) {
    return numeral(value).format('0,0.00');
  }else{
    return '0.00';
  }
})

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('hh:mm A')
  }
})

axios.defaults.withCredentials = false


// Configuration de l'API selon l'environnement
const apiConfig = getApiConfig()
axios.defaults.baseURL = apiConfig.apiUrl

// Log pour vérifier l'URL utilisée
console.log('🌐 URL API configurée:', axios.defaults.baseURL)


axios.defaults.headers = {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'Accept': 'application/json',
    "Content-Type": "application/json",
  };

Object.assign(axios.defaults.headers, {"Authorisation" : store.getters.StateToken })
Object.assign(axios.defaults.headers, {"api-token" : store.getters.StateToken })
Object.assign(axios.defaults.headers, {"solgc-client" : store.getters.StateSchema })

Vue.prototype.$axios = axios
  

axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config;
    
    // Logs détaillés en développement
    if (apiConfig.debug) {
      console.group('🚨 Erreur API')
      console.error('URL:', error.config?.url)
      console.error('Méthode:', error.config?.method)
      console.error('Status:', error.response?.status)
      console.error('Message:', error.message)
      console.groupEnd()
    }
    
    // Gestion des erreurs CORS
    if (error.message && error.message.includes('CORS')) {
      console.error('❌ Erreur CORS détectée:', error.message);
      if (apiConfig.useProxy) {
        console.error('💡 Le proxy devrait résoudre ce problème. Vérifiez vue.config.js');
      } else {
        console.error('💡 Configurez les headers CORS côté serveur API');
      }
    }
    
    // Gestion des erreurs 401
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        store.dispatch('LogOut')
        return router.push('/login')
    }
    
    // Gestion des erreurs réseau
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.error('🌐 Erreur réseau:', error.message);
      if (apiConfig.debug) {
        console.error('💡 Vérifiez votre connexion internet et l\'URL de l\'API');
      }
    }
  }
  
  return Promise.reject(error);
})

// Assainissement des clés localStorage corrompues, AVANT tout montage de composant.
// `localStorage.setItem('business', JSON.stringify(undefined))` écrit la chaîne littérale
// "undefined", sur laquelle tout JSON.parse() lève "SyntaxError: unexpected character at
// line 1 column 1". La valeur pouvait survivre à un rechargement, car les vues enfants
// montent avant que le fetch asynchrone du business n'ait réécrit la clé.
var storedBusiness = localStorage.getItem('business')
if (storedBusiness === 'undefined' || storedBusiness === 'null' || storedBusiness === '') {
  localStorage.removeItem('business')
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
